<template>
  <div v-if="places.length > 0">
    <h2 class="mb-1 font-bold text-sm">検索履歴</h2>
    <div class="bg-gray-light border border-link rounded h-full">
      <ul>
        <li v-for="(place, index) in places" v-bind:key="index">
          <div @click="$emit('openPlace', place)" class="list-item">
            <svg height="24" viewBox="0 0 20 18" width="24" xmlns="http://www.w3.org/2000/svg" class="mr-2 fill-current"><path d="m11.3361153.00000036c-4.69521631.00053723-8.50130707 3.80662798-8.50184357 8.50184427h-2.83427173l3.67473969 3.67473977.06607147.1321429 3.81659903-3.80688267h-2.83427173c-.01506605-3.1729971 2.215593-5.91381324 5.32552164-6.5434812 3.1099286-.62966795 6.2310625 1.02756945 7.4514598 3.95652287 1.2203972 2.92895342.1994123 6.3120737-2.4375206 8.0769314s-6.15377526 1.4188338-8.39618232-.8261046l-1.3389189 1.3437771c2.72028306 2.7209602 6.92909602 3.2752977 10.26113682 1.3514817 3.3320408-1.9238161 4.9562685-5.8459687 3.9598867-9.56225552-.9963818-3.71628675-4.3648665-6.29983234-8.2124063-6.29871602zm-.9444334 4.72313918v4.72313846l4.042991 2.3989774.6801475-1.1426478-3.3035735-1.96465463v-4.01481343z" /></svg>
            <span class="flex-grow">{{ place.name }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    places: function () {
      return this.$store.getters['history/getAll']
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  @apply px-4 py-3 border-b border-gray-default flex items-center text-body-light;
}

ul li:last-of-type .list-item {
  @apply border-0;
}
</style>